<a
  [href]="appStoreLink()?.url ?? appStoreLink()?.route?.path"
  [attr.target]="appStoreLink()?.target"
  [attr.aria-label]="appStoreLink()?.title"
  [attr.aria-description]="'FOOTER.APP_STORE_DESCRIPTION' | translate"
  routerLinkDetector
  matRipple
>
  <sheba-app-store-icon />
</a>
<a
  class="overflow-hidden rounded-md"
  [href]="googleLink()?.url ?? googleLink()?.route?.path"
  [attr.target]="googleLink()?.target"
  [attr.aria-label]="googleLink()?.title"
  [attr.aria-description]="'FOOTER.GOOGLE_PLAY_DESCRIPTION' | translate"
  routerLinkDetector
  matRipple
>
  <sheba-google-play-icon />
</a>
